import { PAGE_STATE, PageState } from './page-constants';

// Load-time tracking: an explicit isLoading wins, otherwise derive it from state.
export const resolvePageLoading = (isLoading?: boolean, state?: PageState): boolean =>
  isLoading ?? state === PAGE_STATE.LOADING;

export const extractTrailingJson = (
  message: string
): { preamble: string; entries: [string, unknown][] } | null => {
  const jsonStart = message.indexOf('{');
  if (jsonStart === -1) return null;
  try {
    const parsed: unknown = JSON.parse(message.slice(jsonStart));
    if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) return null;
    return {
      preamble: message.slice(0, jsonStart).trim(),
      entries: Object.entries(parsed as Record<string, unknown>)
    };
  } catch {
    return null;
  }
};
